<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">冻结会员</span>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回会员信息',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsMembers'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box ">
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">会员头像</label>
                    <wcimage :option="{size:'large'}" :value="param.thumb" />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员名称：{{param.name}}</label>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">会员手机：{{param.phone}}</label>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">冻结原因<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入冻结原因',clearable:true,ischange:true,isinput:true,iskeydown:true,clearable:true,type:'input',width:'400px'}" 
                        :value="param.reason"
                        @finish="(val)=> {
                            if(val.type=='input') {param.reason=val.value;}
                            if(val.type=='change') {param.reason=val.value;}
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">冻结时间<i>*</i></label>
                    <wcselect :option="{placeholder:'请选择冻结时间',ischange:true,width:'250px',clearable:true,filterable:true}" 
                        :value="param.timetype"
                        :list="frozentime"
                        @finish="(val)=> {
                            param.timetype=val.value;
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">上传文件</label>
                    <wcuploadmore :option="{type:'select',width:'800px'}" 
                        :value="param.photos" 
                        @finish="(val)=> {
                            param.photos=val.url;
                        }" 
                    />
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>



<!-- 冻结记录 -->
<div class="TTL-time-line">
    <div class="TTL-time-info" v-for="(item,index) in logs" :key="index">
        <span class="TTL-cover" />
        <div class="TTL-time-name">{{item.inputtime}}</div>
        <div class="TTL-time-name top10">
            <el-tooltip placement="top">
            <template #content>
            <div class="goods-commont-box">
                <el-image :src="item.reportmemberthumb" />
                <div class="goods-commont-content left15">
                <div class="goods-commont-name content">举报人：{{item.reportmembername}}</div>
                </div>
            </div>
            </template>
            <el-image :src="require('@/assets/icon/warning.png')" class="TTL-warning" v-if="item.type==3" />
            </el-tooltip>
            {{item.type==1 ? '【冻结】' : item.type==3 ? '【举报】' : '【解冻】'}}{{item.reason}}
        </div>
        <div class="TTL-photos top15" v-if="item.photo.length > 0">
            <div class="TTL-photos-info" v-for="(photos,pindex) in item.photo" :key="pindex">
            <el-image :src="photos.url" :preview-src-list="item.photolist" fit="cover"/>
            </div>
        </div>
        <div class="TTL-report-goods top10" v-if="item.goodsid > 0" @click="$parent.JUMPVIEW({name:'EsGoods',param:{key:item.goodsname}})">
        <wcimage :option="{size:'mini'}" :value="item.goodsthumb" />
        <span class="TTL-report-name left10">{{item.goodsname}}</span>
        </div>
    </div>
</div>


</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
export default {
    components:{},
    data() {
        return {
            loadingobj:'frozenmember',
            limit:10,  //限制添加数据条数          
            param: {
                id:'',
                pid:'',
                name:'',
                phone:'',
                thumb:'',
                reason:'',
                timetype:'',
                rollbackname:'',
                photos:[]
            },
            logs:[],
            frozentime:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetFrozenTimeType();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有数据正在执行编辑操作，是否要执行覆盖操作 ？',
                    '操作提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetMemberfrozenlog(data.param);
                }).catch(()=> {
                    
                });
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetMemberfrozenlog(data.param);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.param.id==0 || this.param.id=='') {this.$notice({title:'错误提示',message:'请选择要冻结的会员',type:'warning'});return false;}
            if(this.param.reason=='') {this.$notice({title:'错误提示',message:'请填写冻结原因',type:'warning'});return false;}
            if(this.param.timetype=='') {this.$notice({title:'错误提示',message:'请选择冻结时间',type:'warning'});return false;}
            var data=JSON.stringify(this.param);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.SAVE_FROZEN({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                !this.param.rollbackname || this.param.rollbackname=='' ? 
                this.$parent.JUMPVIEW({name:'EsMembers',delname:'EsFrozenMember'}) :
                this.$parent.JUMPVIEW({name:'EsFrozen',delname:'EsFrozenMember'});
            });
        },


        /** 查看分类信息 **/
        GetMemberfrozenlog(data) {

            //填充基础数据
            this.param.id=data.id;
            this.param.name=data.name;
            this.param.pid=data.pid;
            this.param.phone=data.phone;
            this.param.thumb=data.thumb;
            this.param.reason='';
            this.param.photos=[];
            this.param.rollbackname=data.rollbackname;
            this.logs=[];

            //获取冻结跟进记录信息
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.GET_MEMBER_FROZEN_LOG({id:data.id}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.logs=res.data;
            });
        },


        /** 获取商品上下架类型 **/
        GetFrozenTimeType(isfresh) {
            this.$method.GET_FROZEN_TIME_TYPE(isfresh).then((res) => {this.frozentime=res;console.log(res)});
        },



    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
.TTL-member-title {display: inline-block;width:100%;font-size:13px;}

.TTL-time-line {position:absolute;right:0;top:0;width:30%;padding:40px;height: 100%;overflow-y:auto;z-index:20;}
.TTL-time-info {display: inline-block;width:calc(100% - 30px - 2px);padding:15px 15px;border-left:2px solid #E4E7ED;position:relative;color:#333333;font-size:14px;margin-bottom:15px;}
.TTL-cover {position:absolute;width:15px;height:15px;top:0;left:0;margin-top:-8px;margin-left:-8px;border-radius: 50%;background-color: #E4E7ED;}
.TTL-time-info:first-child {border-left:2px solid #666eeb;}
.TTL-time-info:first-child .TTL-cover {background-color:#666eeb;}
.TTL-time-name {display: inline-flex;align-items: center;width:100%;font-size:13px;line-height: 1px;color:#333333;line-height: 18px;position:relative;}
.TTL-time-time {position:absolute;right:0;color:#666666;}
.TTL-photos {display: inline-block;width:100%;}
.TTL-photos-info {display: inline-block;width:70px;height: 70px;border-radius: 15px;margin:0 10px 10px 0;overflow: hidden;cursor: pointer;background-color: #F0F2F5;}
::v-deep(.TTL-photos-info .el-image) {width:70px !important;height: 70px !important;}
::-webkit-scrollbar {width:0;}
.TTL-warning {width:20px;height:20px;margin-right: 2px;}
.goods-commont-box {display:inline-flex;align-items: center;width:180px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.TTL-report-goods {display: inline-flex;align-items: center;padding:5px;width:calc(100% - 10px);border-radius: 5px;background-color: #EBEDF0;cursor: pointer;}
.TTL-report-name {display: inline-block;width:calc(100% - 30px - 10px);font-size:12px;letter-spacing: 1px;line-height: 16px;zoom:.9;color:#666666;}
</style>